import React from "react";
import { Flex } from "antd";
import { PlusCircleFilled, PlusOutlined } from "@ant-design/icons";
import {
    CustomTitle,
    CustomButton,
  } from "../../../components";
import LinkIcon from "../../../assets/images/link-icon.svg";
import EmptyShipmentBg from "../../../assets/images/empty-shipment-bg.svg";
import EmptyShipmentBox from "../../../assets/images/empty-shipment-box.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPermissions } from "../../../common/helper/getPermissions";

const HomeEmptyShipments = ({allPermissions }) => {
  const navigate = useNavigate();

  const handleConnectButtonClick = () => {
    navigate("/settings/couriers");
  };
  const handleShipmentFormModal = () => {
    navigate("/shipment");
  };
  const main_menu = useSelector((state) => state.menu.items);
  const ShipmentPermissions = main_menu?.find((item)=>item?.name ==='Shipment');
  const CouriersPermissions =  main_menu?.find((item)=> item?.name === 'Settings')?.sub_menus?.find((data)=> data?.name === "Transport providers");
  return (
    <Flex justify="center" align="flex-center">
      <Flex
        gap={12}
        vertical={true}
        style={{
          maxWidth: "556px",
          textAlign: "center",
          padding: "24px",
          borderRadius:'16px',
          backgroundColor:'#FFFFFF'
        }}
      >
        
        <CustomTitle
          text={"You’re not tracking any shipments yet"}
          fontSize={16}
          fontWeight={600}
          lineHeight={"20px"}
          color={"#000"}
          marginBottom={0}
        />

        <CustomTitle
          text={
            "To start tracking your shipments, connect your transport providers, or manually enter your shipment tracking IDs."
          }
          fontSize={14}
          fontWeight={400}
          lineHeight={"20px"}
          color={"#000"}
          marginBottom={0}
          marginTop={0}
        />

        {/* {userRole?.toLowerCase() !== "viewer" && ( */}
          <Flex wrap gap={8} align="center" justify="center">

            <CustomButton
              onClick={handleConnectButtonClick}
              height="36px"
              minWidth="170px"
              fontSize="14px"
              text={"Connect providers"}
              bgColor="#F3F3F3"
              borderRadius="40px"
              color="#000"
              boxShadow="none"
              iconPosition="left"
              image={LinkIcon}
              gap="10px"
              lineHeight={"16px"}
              fontWeight={500}
              isFormValid={!CouriersPermissions}
            />


            <CustomButton
              onClick={handleShipmentFormModal}
              height="36px"
              minWidth="178px"
              fontSize="14px"
              text={"Track manually"}
              bgColor="#F3F3F3"
              borderRadius="40px"
              color="#000"
              boxShadow="none"
              iconPosition="left"
              icon={<PlusOutlined />}
              gap="10px"
              lineHeight={"16px"}
              fontWeight={500}
              isFormValid={!ShipmentPermissions}

            />
          </Flex>
        {/* )} */}
      </Flex>
    </Flex>
  );
};

export default HomeEmptyShipments;
